import React, { useEffect } from 'react';
import Modal from 'react-modal';
import './Modal.css';

// Set app element for accessibility
if (typeof document !== 'undefined') {
    Modal.setAppElement('#root');
}

const LogoutModal = ({ onClose, children }) => {
    return (
        <Modal
            isOpen={true} 
            onRequestClose={onClose}
            className="logout-modal"
            overlayClassName="logout-overlay"
            appElement={document.getElementById('root')}
        >
            <div className="modal-content">{children}</div>
        </Modal>
    );
};

export default LogoutModal;
